import { handleActions } from 'redux-actions'
import * as type from './type'
import { LOGIN_SUCCESS } from '../../security/state/auth/type'

export const initialState = {
    employee: null,
    fetching: false,
    error: null,
}

export default handleActions({
    [LOGIN_SUCCESS]: (state, action) => {
        const { user } = action.payload
        return {
            ...state,
            employee: user.employee,
        }
    },
    [type.CHANGE_EMPLOYEE]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            employee: {
                ...state.employee,
                [name]: value,
            },
        }
    },
    [type.SET_SIPGATE_DEVICE_ID_REQUEST]: (state, action) => {
        return {
            ...state,
            error: null,
            fetching: true,
        }
    },
    [type.SET_SIPGATE_DEVICE_ID_SUCCESS]: (state, action) => {
        return {
            ...state,
            fetching: false,
        }
    },
    [type.SET_SIPGATE_DEVICE_ID_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/employee/state/reducer.js